import React from 'react';
import { Box, Typography } from '@mui/material';

import xtramChatbotIcon from '../../assests/images/Icons/xtram-chatbot.png';
import { CHATBOT_HE } from '../chatbotStrings.he';

export default function UiHeader() {
  return (
    <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid', borderColor: 'divider' }}>
      <Box sx={{ px: 2, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          <Box component="img" src={xtramChatbotIcon} alt="Xtram" sx={{ width: 32, height: 32, borderRadius: 1 }} />
          <Box sx={{ textAlign: 'right' }} dir="rtl">
            <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{CHATBOT_HE.uiHeaderTitle}</Typography>
            <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>{CHATBOT_HE.uiHeaderSub}</Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            px: 1.5,
            py: 0.75,
            bgcolor: '#f9fafb',
            border: '1px solid #e5e7eb',
            borderRadius: 999,
          }}
        >
          <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'text.secondary' }}>{CHATBOT_HE.statusActive}</Typography>
        </Box>
      </Box>
    </Box>
  );
}

